import Vue from 'vue'

export default {
    UPDATE_CORPORATION (state, value) {
        Vue.set(state, 'corporations', value);
    },
    SET_CORPORATIONS (state, value) {
        this.commit('UPDATE_CORPORATION', value);
    },
    SET_SELECTED_CORPORATION (state,  value ) {
      Vue.set(state, 'selectedCorporation', value);
    },
  SET_SUBSCRIBERREPORT (state,  value ) {
    Vue.set(state, 'subscribers', value);
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/corporations/mutations.js